import React from 'react'
import styled from 'styled-components'
import  Disenrollment from './Disenrollment'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`
const ReportContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`
const TitleContainer = styled.div`
  width: 100%;
  padding: 0 30px 30px 30px;
  box-sizing: border-box;
  display: flex;
`

const DisenrollmentReports = ({ fromCenter, match }) => (
  <Container>
    {!fromCenter && (
      <TitleContainer>
        <h1>Bajas</h1>
      </TitleContainer>
    )}
    <ReportContainer>
      <Disenrollment match={match} fromCenter={fromCenter} />
    </ReportContainer>
  </Container>
)

export default DisenrollmentReports



// WEBPACK FOOTER //
// ./src/Containers/Reports/DisenrollmentReports.jsx